import { ClientProfile, StatusOptions } from '@shared/models';
export interface Client {
  id: number;
  profile: ClientProfile;
  businessName: string;
  name: string;
  surname: string;
  email: string;
  dni: string;
  phone: string;
  address: string;
  institutionIds: number[];
  supplierId: number;
  associatedDoctors?: number[];
  erkom: boolean;
  vacuumBell: boolean;
  fmf: boolean;
  fmfModelId: number;
  argentina: boolean;
  comex: boolean;
  regionId: number;
  institutionCustomName: string;
  status: StatusOptions;
}

export interface ClientListItem {
  id: number | null;
  fullname: string;
  profile: string;
  institution: string;
  email: string;
  commerce: string;
  status: string;
}